import React from "react";
import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import FieldWrapper from "../../FieldWrapper";
import Radio from "../radio/Radio";
import { Error, required } from "../../../../components/reserve-form/FormService";

/**
 * @typedef {Object} QuestionaryAnswer
 * @property {number|null} id
 * @property {number|null} questionId
 * @property {string|null} text
 * @property {string|null} valueCode
 * @property {number|null} position
 */

/**
 * @typedef {Object} QuestionaryQuestion
 * @property {number|null} id
 * @property {number|null} questionaryId
 * @property {string|null} text
 * @property {string|null} answerType
 * @property {string|null} prefixCode
 * @property {number|null} position
 * @property {boolean} required
 * @property {boolean} active
 * @property {QuestionaryAnswer[]|null} answers
 */

/**
 * @typedef {Object} Questionary
 * @property {number|null} id
 * @property {string|null} name
 * @property {boolean} active
 * @property {QuestionaryQuestion[]|null} questions
 */

/**
 * @param {{ prefix: string, questionary: Questionary }} props
 */

export default function QuestionaryField({name, questionary}) {
    if (!questionary?.questions?.length) return null;

    const filtered = questionary.questions.filter(q =>
        ["Options", "FreeText"].includes(q.answerType)
    );

    return (
        <div className="field-group row g-3">
            {
                questionary.description && questionary.description.length > 0 && (
                    <div className="col-12">
                        <FieldWrapper>
                            <label style={{
                                textAlign: 'justify',
                                whiteSpace: 'pre-line'
                            }}>{questionary.description}</label>
                        </FieldWrapper>
                    </div>
                )
            }
            <FieldArray name={name}>
                {({fields}) => {

                    filtered.forEach((question, qIndex) => {
                        if (!fields.value || !fields.value[qIndex]) {
                            fields.value = fields.value || [];
                            fields.value[qIndex] = {
                                questionId: question.id,
                                answerId: null,
                                text: null
                            };
                        }
                    });

                    return filtered.map((question, qIndex) => {
                        const base = `${name}[${qIndex}]`;

                        if (question.answerType === "Options") {
                            return (
                                <div className="col-lg-6" key={question.id}>
                                    <FieldWrapper>
                                        <label>
                                            {question.text} {question.required &&
                                            <span className="text-danger">*</span>}
                                        </label>

                                        {question.answers.map((answer, ai) => (
                                            <div className="col-12" key={answer.id}>
                                                <Field
                                                    name={`${base}.answerId`}
                                                    aria-label={`${base}.answerId`}
                                                    component={Radio}
                                                    aria-required="true"
                                                    validate={question.required ? required : undefined}
                                                    radioId={`${name}.${qIndex}_${ai}`}
                                                    type="radio"
                                                    value={String(answer.id)}
                                                    parse={v => (v ? Number(v) : null)}
                                                    format={(v) => (v != null ? String(v) : undefined)}
                                                >
                                                    {answer.text}
                                                </Field>

                                            </div>
                                        ))}

                                        <Field
                                            name={`${base}.questionId`}
                                            component="input"
                                            type="hidden"
                                            initialValue={question.id}
                                        />

                                        <Error
                                            label="Questionnaire answer"
                                            name={`${base}.answerId`}
                                        />
                                    </FieldWrapper>
                                </div>
                            );
                        }

                        if (question.answerType === "FreeText") {
                            return (
                                <div className="col-lg-12" key={question.id}>
                                    <FieldWrapper>
                                        <label>
                                            {question.text} {question.required &&
                                            <span className="text-danger">*</span>}
                                        </label>

                                        <Field
                                            name={`${base}.text`}
                                            component="textarea"
                                            validate={question.required ? required : undefined}
                                            maxLength={1500}
                                        />

                                        <Field
                                            name={`${base}.questionId`}
                                            component="input"
                                            type="hidden"
                                            initialValue={question.id}
                                        />

                                        <Error
                                            label="Questionnaire answer"
                                            name={`${base}.text`}
                                        />
                                    </FieldWrapper>
                                </div>
                            );
                        }
                        return null;
                    });
                }}
            </FieldArray>
        </div>
    );
}

